import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  FiDollarSign, 
  FiPieChart, 
  FiLink, 
  FiTrendingUp,
  FiMenu,
  FiX
} from 'react-icons/fi';
import './Navbar.css';

const AffiliateNavbar = ({siteName}) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Dashboard', icon: <FiPieChart />, href: '#dashboard' },
    { name: 'Offers', icon: <FiDollarSign />, href: '#offers' },
    { name: 'Links', icon: <FiLink />, href: '#links' },
    { name: 'Analytics', icon: <FiTrendingUp />, href: '#analytics' },
  ];

  return (
    <motion.nav 
      className={`affiliate-navbar ${scrolled ? 'scrolled' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="navbar-container">
        {/* Logo/Brand */}
        <motion.div 
          className="navbar-brand"
          whileHover={{ scale: 1.03 }}
        >
          <FiDollarSign className="brand-icon" />
          <span>{siteName}</span>
        </motion.div>

        {/* Desktop Navigation */}
        <div className="desktop-nav">
          {navItems.map((item, index) => (
            <motion.a
              key={index}
              href={item.href}
              className="nav-item"
              whileHover={{ 
                y: -2,
                color: '#6366F1'
              }}
              transition={{ duration: 0.2 }}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.name}
            </motion.a>
          ))}
        </div>


      </div>

      {/* Mobile Menu */}
      <motion.div 
        className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}
        initial={{ opacity: 0, height: 0 }}
        animate={{ 
          opacity: mobileMenuOpen ? 1 : 0,
          height: mobileMenuOpen ? 'auto' : 0
        }}
        transition={{ duration: 0.3 }}
      >
        {navItems.map((item, index) => (
          <motion.a
            key={index}
            href={item.href}
            className="mobile-nav-item"
            onClick={() => setMobileMenuOpen(false)}
            whileHover={{ backgroundColor: 'rgba(99, 102, 241, 0.1)' }}
            initial={{ x: -20, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ delay: index * 0.05 }}
          >
            <span className="mobile-nav-icon">{item.icon}</span>
            {item.name}
          </motion.a>
        ))}
        
        <motion.button
          className="mobile-cta"
          onClick={() => setMobileMenuOpen(false)}
          whileHover={{ backgroundColor: 'rgba(99, 102, 241, 0.2)' }}
        >
          Get Started
        </motion.button>
      </motion.div>
    </motion.nav>
  );
};

export default AffiliateNavbar;